import axios from "axios";
import { getJWTTokenFromCookie, clearCookieData } from "../utils";

const BASIC_SUBSCRIPTION_DISABLED_MESSAGE =
  "This portal is currently disabled. Please contact your administrator.";

axios.interceptors.request.use(
  (config) => {
    config.headers.authorization = getJWTTokenFromCookie();
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response?.status === 401) {
      clearCookieData();
      window.location = "/";
    }

    if (
      error.response?.status === 403 &&
      getJWTTokenFromCookie() &&
      error.response.data?.message === BASIC_SUBSCRIPTION_DISABLED_MESSAGE
    ) {
      clearCookieData();
      window.location = "/";
    }

    return Promise.reject(error);
  }
);

export default axios;
